<template>
  <div>
    <basic-container>
      <el-form
        :inline="true"
        :model="selectForm"
        status-icon
        ref="searchFormRef"
        label-width="100px"
        class="only-one"
        v-show="searchBoxFlag"
      >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="项目名称" prop="projectId">
            <el-select v-model="selectForm.projectId" placeholder="请选择">
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="盘点单号" prop="code">
            <el-input v-model="selectForm.code" placeholder="盘点单号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="任务名称" prop="name">
            <el-input v-model="selectForm.name" placeholder="任务名称" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="float:right">
                              <el-button type="primary" icon="el-icon-search"  size="small" @click="deviceInventorySearch">搜索</el-button>
            <el-button  icon="el-icon-delete" size="small" @click="searchReset">清空</el-button>
                </div>

        </el-col>
      </el-row>
      </el-form>

      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="deviceList"
        :page.sync="page"
        v-model="selectForm"
        ref="crud"
        @current-change="currentChange"
        @size-change="sizeChange"
        @on-load="onLoad"
        @refresh-change="onLoad"
      >
        <template slot="menuRight">
              <searchFromShow
                :searchBoxFlag.sync='searchBoxFlag'
                :removeHeight ='searchHeight'
                :option='option'
                :refOption="$refs.crud"
                ></searchFromShow>
            </template>
        <template slot="checkedNum" slot-scope="scope">
          <div>{{ scope.row.checkedNum }}/{{ scope.row.totalQuantity }}</div>
        </template>
        <template slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small"  @click="addDeviceInventory">新增盘点</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="text"
            size="small"
            icon="el-icon-tickets"
            @click="checkInventory(scope.row.id)"
            >查看
          </el-button>
          <el-button
            type="text"
            size="small"
            icon="el-icon-edit"
            v-if="scope.row.checkStatus == 0"
            @click="editDeviceInventory(scope.row.id)"
            >编辑
          </el-button>
          <el-button
            type="text"
            size="small"
            icon="el-icon-printer"
            v-if="scope.row.checkStatus == 0"
            @click="updateInventory(scope.row.id,1)"
            >开始盘点
          </el-button>
          <el-button
            type="text"
            size="small"
            icon="el-icon-printer"
            v-if="scope.row.checkStatus == 1"
            @click="updateInventory(scope.row.id,2)"
            >结束盘点
          </el-button>
          <el-button
            type="text"
            size="small"
            icon="el-icon-delete"
            v-if="scope.row.checkStatus == 0"
            @click="removeInventory(scope.row.id)"
            >删除
          </el-button>
          <el-button
            type="text"
            size="small"
            icon="el-icon-printer"
            @click="openEquipmentList(scope.row)"
            >设备清单
          </el-button>
          <el-button
            type="text"
            size="small"
            icon="el-icon-printer"
            v-if="scope.row.checkStatus == 2"
            @click="exportReport(scope.row)"
          >导出报告
          </el-button>

        </template>
      </avue-crud>
       <!-- <el-dialog
            v-if="addOrEditDeviceInventoryFlag"
            :title="title"
            :visible="addOrEditDeviceInventoryFlag"
            width="65%"
            :fullscreen="dialogFull"
            append-to-body
            :close-on-click-modal="false"
          :before-close="addOrEditDeviceInventoryClose"
            >
            <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{title}}
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFullChange"></i>
                        </div>
                        <el-divider></el-divider>
            </template>
           <operate-addor-edit  ref="operateAddOrEditRef" :operateStatus='operateStatus' :projectId="selectForm.projectId" :projectList='projectList' :code='addInventoryCode' @closeDialog='addOrEditDeviceInventoryClose'></operate-addor-edit>

        </el-dialog> -->
        <hr-dialog
           v-if="addOrEditDeviceInventoryFlag"
            :title="title"
            :visible="addOrEditDeviceInventoryFlag"
            width="65%"

          :handleClose="addOrEditDeviceInventoryClose"
        >
            <template slot="body">
                <operate-addor-edit  v-if="addOrEditDeviceInventoryFlag" :inventoryPeople='inventoryPeople' :title="title" ref="operateAddOrEditRef" :operateStatus='operateStatus' :projectId="selectForm.projectId" :projectList='projectList' :code='addInventoryCode' @closeDialog='addOrEditDeviceInventoryClose'></operate-addor-edit>
            </template>
        </hr-dialog>
    </basic-container>


  </div>
</template>

<script>
import { getProjectList } from '@/api/crmedical/project/project';
import operateAddorEdit from './operateAddorEdit.vue';
import {
  getInventoryList,
  getInventoryCode,
  updatetInventoryStatus,
  getInventoryDetail,
  removeInventory,
} from '@/api/crmedical/device/deviceInventory';
import { constants } from 'zlib';
import {getContentName, getPreviewInfo} from "@/api/crmedical/value/valuebudget";
import urlSettings from "@/config/url-settings";
import searchFromShow from '@/components/search-form-show/index'
import dayjs from "dayjs";
import { type } from 'os';
export default {
  components: {
    operateAddorEdit,
    searchFromShow
  },
  data() {
    return {
      addYes:0,
      dialogFull:false,
      searchBoxFlag:true,
        searchHeight:'',
      editDeviceDetail: {},
      selectForm: {
        projectId: '',
        code: '',
        name: '',
      },
      title: '', //新增查看编辑对话框的标题
      //页面操作状态 1 新增 2 编辑 3 查看
      operateStatus: '',
      addInventoryCode: '',
      addOrEditDeviceInventoryFlag: false, //新增,修改盘点对话框
      deviceList: [],
      option: {
        index: true,
        // selection: true,
        // reserveSelection:true,
        indexLabel: '序号',
        page: true,
        align: 'left',
        menuAlign: 'center',
        addBtn:false,
        editBtn: false,
        delBtn: false,
        border:true,
        height:'auto',
        column: [
          {
            label: '盘点单号',
            prop: 'code',
          },
          {
            label: '项目名称',
            prop: 'projectName',
          },
          {
            label: '任务名称',
            prop: 'name',
          },
          {
            label: '盘点开始时间',
            prop: 'checkStartTime',
            format:"yyyy-MM-dd",
             type:"date"
          },
          {
            label: '盘点结束时间',
            prop: 'checkEndTime',
            format:"yyyy-MM-dd",
            type:"date"
          },
          {
            label: '盘点人',
            prop: 'checkUsers',
          },
          {
            label: '状态',
            prop: 'checkStatus',
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=device_check_status',
          },
          {
            label: '已盘点/总数量',
            prop: 'checkedNum',
            slot: true,
          },
        ],
      },
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      form: {},
      projectList: [], //部门list
      inventoryPeople:[]
    };
  },
  created() {
    // this.initData();
  },
  watch:{
    '$route.path':function(newVal,oldVal){
          // console.log(newVal + '---' +  oldVal);
          if(newVal === '/crmedical/device/deviceInventory/index'){
             this.$refs.crud.$refs.table.doLayout()
          }
        }
  },
  mounted(){
    console.log(this.$route)
    console.log("-------",  this.$refs.crud.$refs.table.doLayout())
     this.calcHeight()
    //   this.$nextTick(() => {
    //   this.$refs.crud.$refs.table.doLayout()
    // })
  },

  methods: {
    dialogFullChange(){
                        this.dialogFull = !this.dialogFull;
                },
    calcHeight(){
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight
      this.option.height = this.bodyHeight - this.searchHeight-279;
    },
    openEquipmentList(row) {
      console.log(row);
      let path = ''; //urlSettings.VUE_APP_BASE_REPORT_URL + '/fastNewbill.cpt&op=write&payBillNo='+111111;
      // path =
      //   urlSettings.VUE_APP_BASE_REPORT_URL +
      //   `/valueDeclarePreview.cpt` +

     path =  urlSettings.VUE_APP_BASE_REPORT_URL +
      'equipmentListReport.cpt&projectId='
      +row.projectId
      +'&checkId='+row.id

      // path = 'http://localhost:8075/WebReport/ReportServer?reportlet=test%2Ftest1.cpt&projectId='
      //  + row.projectId
      //  + '&checkId=' + row.id

      window.open(
        path,
        'newindow',
        'height=600,width=1100,top=100,left=100,toolbar=no,' +
        'menubar=no,scrollbars=no,resizable=no,location=no,status=no,z-look=yes'
      );
    },
     exportReport(row) {
      console.log('导出');
      let path = ''; //urlSettings.VUE_APP_BASE_REPORT_URL  + '/fastNewbill.cpt&op=write&payBillNo='+111111;
      // path =
      //   urlSettings.VUE_APP_BASE_REPORT_URL +

      //   `/valueDeclarePreview.cpt` +

      // path = 'http://localhost:8075/WebReport/ReportServer?reportlet=test%2Ftest1.cpt&projectId='
      //  + row.projectId
      //  + '&checkId=' + row.checkId
       let title = row.projectName + ' ' + row.name + " 设备资产盘点表";
       let time = "盘点日期: " +
         this.dayjs(row.checkStartTime).format('YYYY年MM月DD日')
         + "至" +
         this.dayjs(row.checkEndTime).format('YYYY年MM月DD日');
       let remark = "盘点任务备注: " + row.description
       console.log(row)
       path =  urlSettings.VUE_APP_BASE_REPORT_URL +

         'exportReport.cpt&projectId='
         +row.projectId
         +'&checkId='+row.id
         + '&title=' + title
         + '&time=' + time
         + '&remark=' + remark


       // let remark = "盘点任务备注: " + row.remark
       // path = 'http://localhost:8075/WebReport/ReportServer?reportlet=exportReport.cpt&projectId='
       //   + row.projectId
       //   + '&checkId=' + row.id
       //   + '&title=' + title
       //   + '&time=' + time
       //   + '&remark=' + remark

      window.open(
        path,
        'newindow',
        'height=600,width=1100,top=100,left=100,toolbar=no,' +
        'menubar=no,scrollbars=no,resizable=no,location=no,status=no,z-look=yes'
      );
    },

    searchReset(){

      this.selectForm.code='';
      this.selectForm.name=''
    },
     sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
    currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
    checkInventory(id) {
      getInventoryDetail(id).then(({ data }) => {
        this.editDeviceDetail = data;
        this.operateStatus = '3';
        this.title = '详情';
        this.inventoryPeople = data.checkPcUserNames
        this.addOrEditDeviceInventoryFlag = true;
        //设备信息

        this.$nextTick(() => {
          console.log(this.$refs['operateAddOrEditRef']);
          this.$refs['operateAddOrEditRef'].submitDeviceList = data.deviceCheckDetail;
          let obj = {};
          obj.code = data.code;
          obj.projectId = data.projectId;

          obj.name = data.name;
          obj.description = data.description;
          obj.checkEndTime = data.checkEndTime;
          obj.checkStartTime = data.checkStartTime;
          obj.checkTime = [data.checkStartTime, data.checkEndTime];
          obj.id = id;

          let checkUser = data.checkPcUserNames;
          let arry = [];
          let checkUserIdsArry = [];
          let checkPcUserNamesArry = [];
          if (checkUser.length > 0) {
            for (let i = 0; i < checkUser.length; i++) {

              let obj = {
                realNameAndPhone: checkUser[i].realName,
                id: checkUser[i].id,
              };
              arry.push(obj);
              checkPcUserNamesArry.push(checkUser[i].realName);
              checkUserIdsArry.push(checkUser[i].id);
            }
          }

          let checkUserIds = checkUserIdsArry.join(',');
          let checkPcUserNames = checkPcUserNamesArry.join(',');
          obj.checkUserIds = checkUserIds;
          this.$refs['operateAddOrEditRef'].deviceInventoryForm = obj;

          this.$refs['operateAddOrEditRef'].checkPcUserNames = checkPcUserNames;
          this.$refs['operateAddOrEditRef'].remainUserList = arry;
          console.log('ddd',this.$refs['operateAddOrEditRef'].choicePeopleOption.selectList )
        });
      });
    },
    removeInventory(id) {
      this.$confirm('是否进行操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          removeInventory(id).then(() => {
            this.$message({
              message: '删除成功',
              type: 'success',
            });
            this.onLoad();
          });
        })
        .catch(() => {
          return;
        });
    },
    //编辑
    editDeviceInventory(id) {
      getInventoryDetail(id).then(({ data }) => {
        this.editDeviceDetail = data;
        this.operateStatus = '2';
        this.title = '编辑';
        this.inventoryPeople = data.checkPcUserNames
        this.addOrEditDeviceInventoryFlag = true;
        //设备信息

        this.$nextTick(() => {
          console.log(this.$refs['operateAddOrEditRef']);
          this.$refs['operateAddOrEditRef'].submitDeviceList = data.deviceCheckDetail;
          let obj = {};
          obj.code = data.code;
          obj.projectId = data.projectId;

          obj.name = data.name;
          obj.description = data.description;
          obj.checkEndTime = data.checkEndTime;
          obj.checkStartTime = data.checkStartTime;
          obj.checkTime = [data.checkStartTime, data.checkEndTime];
          obj.id = id;

          let checkUser = data.checkPcUserNames;
          let arry = [];
          let checkUserIdsArry = [];
          let checkPcUserNamesArry = [];
          if (checkUser.length > 0) {
            for (let i = 0; i < checkUser.length; i++) {
              let obj = {
                realNameAndPhone: checkUser[i].realName,
                id: checkUser[i].id,
              };
              arry.push(obj);
              checkPcUserNamesArry.push(checkUser[i].realName);
              checkUserIdsArry.push(checkUser[i].id);
            }
          }
          let checkUserIds = checkUserIdsArry.join(',');
          let checkPcUserNames = checkPcUserNamesArry.join(',');
          obj.checkUserIds = checkUserIds;
           this.$refs['operateAddOrEditRef'].choicePeopleOption.selectList = checkUser;
           console.log('ddd',this.$refs['operateAddOrEditRef'].choicePeopleOption.selectList )
          this.$refs['operateAddOrEditRef'].deviceInventoryForm = obj;
          this.$refs['operateAddOrEditRef'].checkPcUserNames = checkPcUserNames;
          this.$refs['operateAddOrEditRef'].remainUserList = arry;
        });
      });
    },
    updateInventory(id, status) {
      this.$confirm('是否进行操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          updatetInventoryStatus({ id, deviceCheckStatus: status }).then(() => {
            this.$message({
              message: '操作成功',
              type: 'success',
            });
            this.onLoad();
          });
        })
        .catch(() => {
          return;
        });
    },
    //新增盘点
    addDeviceInventory() {
      this.inventoryPeople = []
      getInventoryCode().then(({ data }) => {
        //盘点单号
        this.addInventoryCode = data;
        this.operateStatus = '1';
        this.title = '新增';

        this.addOrEditDeviceInventoryFlag = true;
        this.$nextTick(()=>{
           console.log('ddd',this.$refs['operateAddOrEditRef'].choicePeopleOption.selectList )
        })

      });
    },
    addOrEditDeviceInventoryClose() {
      this.addOrEditDeviceInventoryFlag = false;
      this.onLoad();
    },
    initData() {
      //获取部门
      getProjectList().then((data) => {
        this.projectList = data.data;
        //默认选择第一个
        this.selectForm.projectId = this.projectList[0].id;
        this.onLoad();
      });
    },
    //搜索
    deviceInventorySearch() {
      this.onLoad();
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
     if(this.selectForm.projectId){
       getInventoryList(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.selectForm)
      ).then(({ data }) => {
        this.deviceList = data.records;
        this.page.total = data.total;
        this.loading = false;
      }).catch(()=>{
         this.loading = false;
      })
     }else{
       this.initData()
     }
    },
  },
};
</script>

<style scoped>
::v-deep .only-one .el-form-item  {
  display: flex
}</style>
